import { UserEntityModel } from "src/store/models/entity/user/entity";
import { UserHelperModel } from "src/store/models/entity/user/helper";
import { UserListModel } from "src/store/models/entity/user/list";

export const encooUserModels = {
  entity: UserEntityModel,
  helper: UserHelperModel,
  list: UserListModel,
};
